export const WorkData = [
    {
        company: "LetsGrowMore",
        designation: "WEB DEVELOPER",
        dateJoining: "Sept-2021",
        dateEnd: "Oct-2021",
        companyLogo: "https://letsgrowmore.in/wp-content/uploads/2021/05/cropped-growmore-removebg-preview.png",
        work: "Developed React JS and PHP web applications Educational Institutions' administers."
    },
    {
        company: "The Sparks Foundation",
        designation: "WEB DEVELOPER",
        dateJoining: "Aug-2021",
        dateEnd: "Sept-2021",
        companyLogo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRYpTjQxXSy1iwgCtp_KWsjHZD3caMlBZPaQUM8vqvUlvOt1e56qS8VqdKeGLNjM_hC_70&usqp=CAU",
        work: "Worked on REST APIs using NodeJS and MongoDB. Payment Integration, Banking and Security."
    },
    {
        company: "Trible Connect: Connecting Our Roots",
        designation: "WEB DEVELOPER",
        dateJoining: "June-2021",
        dateEnd: "Aug-2021",
        companyLogo: "https://tribalconnect.org.in/img/logo.png",
        work: "Worked with a small team as a BackEnd Developer.There I have handled the server side of the Website and worked with technologies such as PHP, Hostinger, Remote MySQL Designed the UI and deployed the project within the decided timeline."
    },
]